module.exports = __webpack_public_path__ + "img/close.bb7d7189.svg";